<template>
   <div class="block max-w-sm p-6 transparent-card">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-darkblue">
         {{ surah.nama }}
      </h5>
      <div class="flex justify-between items-center">
         <ul class="max-w-md space-y-1 text-white font-medium">
            <li>{{ surah.arti }}</li>
            <li>Ayat : {{ surah.ayat }}</li>
            <li>Turun :{{ surah.type }}</li>
         </ul>
         <div class="text-4xl font-semibold text-darkblue">
            {{ surah.asma }}
         </div>
      </div>

      <div class="btn-primary mt-3 flex justify-center items-center">
         <router-link :to="`/surah/${surah.nomor}`">See detail</router-link>
      </div>
   </div>
</template>

<script>
export default {
   name: "CardComponent",
   props: ["surah"],
};
</script>

<style></style>
